import { Button, Flex, Grid, Text } from "@chakra-ui/react";
import { SolicitacaoCadastroDetails } from "core/features/SolicitacaoCadastro/typings";
import Center from "ui/components/Center";
import Heading from "ui/components/text/heading";

function Documentos({ data }: { data: SolicitacaoCadastroDetails }) {
  return (
    <Grid
      alignItems="center"
      paddingBottom="40px"
      bg="#FFFFFF"
      borderRadius={16}
    >
      <Heading mx="24px" marginTop="21px" mb="21px">
        Documentos
      </Heading>

      <Flex
        mx="24px"
        h="40px"
        mb="21px"
        style={data.documentoImovel ? { borderLeft: "5px solid #5081FF" } : {}}
      >
        {data?.documentoImovel ? (
          <DocumentoImov
            title="Documentação do imóvel"
            url={data.documentoImovel}
          />
        ) : null}
      </Flex>
      <Flex
        mx="24px"
        h="40px"
        style={data.documentoPessoal ? { borderLeft: "5px solid #5081FF" } : {}}
      >
        {data?.documentoPessoal ? (
          <DocumentoProp
            title="Documento Proprietário"
            url={data.documentoPessoal}
          />
        ) : null}
      </Flex>
    </Grid>
  );
}

function DocumentoImov({ title, url }: { title: string; url: string }) {
  return (
    <Flex
      bg="#FFFFFF"
      rounded="2x1"
      mx="14px"
      paddingTop="10px"
      borderRadius={16}
    >
      <Text textAlign="center" fontSize="17px" mb="21px">
        {title}
      </Text>
      <Center>
        <a download href={url} target="_blank" rel="noreferrer">
          <Button
            width="76px"
            height="24px"
            left="90px"
            colorScheme="blue"
            variant="outline"
          >
            Ver
          </Button>
        </a>
      </Center>
    </Flex>
  );
}
function DocumentoProp({ title, url }: { title: string; url: string }) {
  return (
    <Flex bg="#FFFFFF" rounded="2x1" mx="14px" paddingTop="10px">
      <Text textAlign="center" fontSize="17px" mb="21px">
        {title}
      </Text>
      <Center>
        <a download href={url} target="_blank" rel="noreferrer">
          <Button
            marginLeft="19px"
            width="76px"
            height="24px"
            left="90px"
            colorScheme="blue"
            variant="outline"
          >
            Ver
          </Button>
        </a>
      </Center>
    </Flex>
  );
}

export default Documentos;
